import { Step, StepButton, StepLabel, Stepper } from "@mui/material";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Icon, { IconName } from "../Icon/Icon";
import "./ProposalStepper.scss";

export const ProposalStepIcon = props => {
  const { active, icon } = props;

  return (
    <div className={`stepper__icon ${active ? "stepper__icon--active" : "stepper__icon--inactive"}`}>
      {active ? (
        <Icon name={IconName.ActiveFormStep} size="32px" />
      ) : (
        <Icon name={IconName.InactiveFormStep} size="32px" />
      )}
      <span className="stepper__icon-number">{icon}</span>
    </div>
  );
};

export interface IStep {
  label: string;
  to?: string;
  completed?: boolean;
  optional?: boolean;
}

export interface IStepperProps extends RouteComponentProps {
  steps: IStep[];
  activeStep: number;
  isClassificationLoaded?: boolean;
  onClick: (e: any, stepIndex: number) => any;
}

export interface IStepperState {
  activeStep: number;
  skipped: any;
  completed: any;
}

export class ProposalStepper extends React.Component<IStepperProps, IStepperState> {
  render() {
    const { steps, onClick, activeStep, isClassificationLoaded } = this.props;

    function getStepActiveState(activeStep: number, index: number) {
      return activeStep === index ? "stepper__step__active" : "stepper__step__inactive";
    }

    return (
      <div className="stepper">
        <div>
          <Stepper alternativeLabel nonLinear activeStep={activeStep}>
            {steps.map((step, index) => (
              <Step className="stepper__step" key={step.label}>
                <StepButton disabled={!isClassificationLoaded} onClick={e => onClick(e, index)}>
                  <StepLabel StepIconComponent={ProposalStepIcon}>
                    <span className={getStepActiveState(activeStep, index)}>{step.label}</span>
                  </StepLabel>
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </div>
      </div>
    );
  }
}

export default withRouter(ProposalStepper);
